import React from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";

import Logo from "../../assets/images/logos/logo2.png";
import CurrentAffairsMain from "./CurrentAffairsMain";

const CurrentAffairs = () => {
  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        topbarEnable="enable"
      />
      <div class="react-wrapper">
        <div class="react-wrapper-inner">
          {/* <Breadcrumb pageTitle="Jnani Junction - Current Affairs Hub" /> */}

          {/* <CurrentAffairsMain /> */}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>
      <FooterTwo />
    </>
  );
};

export default CurrentAffairs;
